import {
    Component,
    NgModule,
    ViewChild,
    ViewContainerRef,
    ReflectiveInjector,
    ComponentFactoryResolver,
    Input,
    Output,
    EventEmitter,
    OnDestroy} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';

import { Subscription } from 'rxjs';
import { FileUploadModule  } from 'ng2-file-upload';

import { MinMaxValidatorModule } from '../../directives/min-max-validator.directive';

import { LayerPopClaimComponent } from './layer-pop-claim-component';
import { LayerPopChatRoomSetComponent } from './layer-pop-chatroomset';
import { LayerPopFightCreateComponent } from './layer-pop-fight-create-component';
import { LayerPopPointGiftComponent } from './layer-pop-pointgift';
import { LayerPopAddFriendComponent } from './layer-pop-addfriend';
import { ObjToArrayPipeModule } from '../../pipes/objtoarray.pipe';


// import { LayerPopGoalSetComponent } from './layer-pop-goalset-component';

import { EventService } from '../../services/event.service';


@Component({
    selector: 'pop-over',
    template: `
        <ng-template #container></ng-template>
    `
})

export class PopOverComponent implements OnDestroy {
    @ViewChild('container', {read: ViewContainerRef, static: true}) container: ViewContainerRef;
    private subscription: Subscription;

    component: any;
    componentData: any;
    currentComponent: any;
//    pick: string;
    inputObj: any;

    // @Input()  componet: string;
    showflag = false;


    @Input('component') set mycomponent(value: string) { // popover.component
        this.component = value;
        if (this.showflag) {
            this.create();
        }
        // this.tabObject.pick = pick;
    }
    @Input('paramObj') set myparamObj(value: any) { // {pick: 'powerLadder', tab: 'picks' }
        this.inputObj = value;
        if (this.showflag) {
            this.create();
        }
    }

    @Output() show = new EventEmitter<boolean>();

    constructor(
        private resolver: ComponentFactoryResolver,
        private eventService: EventService
    ) {
        this.subscribe();
    }

    ngOnDestroy() { // 이곳에서는 채팅과 관련된 모든 사항을 종료시키다.
        this.subscription.unsubscribe();
    }

    subscribe() {
        this.subscription = this.eventService.subscribe('popup', (payload) => {
            if (payload.type === 'popup') {
                this.component = payload.component;
                this.inputObj = typeof payload.params === 'undefined' ? {} : payload.params;
                this.create();
            }
            // {type: popup, component: ddddd, params: {}}
        });
    }

    closePopover() {
        this.currentComponent.destroy();
        this.showflag = false;
        this.show.emit(false);
    }

    init() {
    //    if (this.showflag) {
    //        this.create();
        // }
    }

    create() {
        switch (this.component) {
            case 'fight-create': // 결투방 생성
                this.componentData = {
                    component: LayerPopFightCreateComponent,
                    inputs: {
                        paramObj: this.inputObj
                    }
                };
                break;
            case 'claim-create': // 클레임
                this.componentData = {
                    component: LayerPopClaimComponent,
                    inputs: {
                        paramObj: this.inputObj
                    } // ,
                };
                break;
            case 'chatroom-create': // 채팅룸생성
                this.componentData = {
                    component: LayerPopChatRoomSetComponent,
                    inputs: {
                        paramObj: this.inputObj
                    } // ,
                };
                break;
            case 'point-gift': // 채팅룸에서 포인트 선물하기
                this.componentData = {
                    component: LayerPopPointGiftComponent,
                    inputs: {
                        paramObj: this.inputObj
                    } // ,
                };
                break;
            case 'add-friend': //  친구추가하기
                this.componentData = {
                    component: LayerPopAddFriendComponent,
                    inputs: {
                        paramObj: this.inputObj
                    } // ,
                };
                break;
        }

        if (!this.componentData.component) {
            return;
        }
        // Inputs need to be in the following format to be resolved properly
        const inputProviders = Object.keys(this.componentData.inputs).map((inputName) => {
            return { provide: inputName, useValue: this.componentData.inputs[inputName] };
        });

        const resolvedInputs = ReflectiveInjector.resolve(inputProviders);

        // We create an injector out of the data we want to pass down and this components injector
        const injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, this.container.parentInjector);
        // We create a factory out of the component we want to create
        const factory = this.resolver.resolveComponentFactory(this.componentData.component);


        //   circleCompRef.instance.bgColor = bgColor;

        // We create the component using the factory and the injector
        const component = factory.create(injector) as any; // as any type으로 형을 선언해 주어야 component.instance.popclosed 에서 에러가 발생하지 않음

        // We insert the component into the dom container
        console.log(this.container);
        this.container.insert(component.hostView, 0);

        // We can destroy the old component is we like by calling destroy
        if (this.currentComponent) {
            this.currentComponent.destroy();
        }

        this.currentComponent = component;

        // close popover listen
        component.instance.popclosed.subscribe(() => this.closePopover());
    }

}

@NgModule({
    declarations: [
        PopOverComponent,
        LayerPopFightCreateComponent,
        LayerPopClaimComponent,
        LayerPopChatRoomSetComponent,
        LayerPopPointGiftComponent,
        LayerPopAddFriendComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatSelectModule,
        MatRadioModule,
        MatInputModule,
        FileUploadModule,
        MinMaxValidatorModule,
        ObjToArrayPipeModule,
        MatIconModule
    ],
    exports: [
        PopOverComponent
    ],
    entryComponents: [
        PopOverComponent,
        LayerPopFightCreateComponent,
        LayerPopClaimComponent,
        LayerPopChatRoomSetComponent,
        LayerPopPointGiftComponent,
        LayerPopAddFriendComponent
    ]
})
export class PopOverModule { }
